import { render, staticRenderFns } from "./AddPatientChooseProgram.vue?vue&type=template&id=428c2846&scoped=true"
import script from "./AddPatientChooseProgram.vue?vue&type=script&lang=js"
export * from "./AddPatientChooseProgram.vue?vue&type=script&lang=js"
import style0 from "./AddPatientChooseProgram.vue?vue&type=style&index=0&id=428c2846&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428c2846",
  null
  
)

export default component.exports